import { useMemo } from "react";
import {
  useGetContractorQuery,
  useGetContractorsQuery,
} from "./contractorEndpoints";
import { Contractor } from "../../entities/contractor";
import { Ids } from "../../reducers/rhapsody";

export function useContractor(ids?: Ids) {
  const contractorQuery = useGetContractorQuery(ids, {
    skip: (ids?.id ?? 0) <= 0,
  });
  const contractorEntity = contractorQuery.data;

  return useMemo(() => {
    const ret: typeof contractorQuery & {
      contractor?: Contractor | undefined;
    } = {
      ...contractorQuery,
    };
    if (contractorEntity) ret.contractor = new Contractor(contractorEntity);
    return ret;
  }, [contractorEntity]);
}

export function useContractors() {
  const contractorQuery = useGetContractorsQuery();
  const contractorEntitiesMap = contractorQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof contractorQuery & {
      contractors?: Contractor[];
      contractorsMap?: { [id: number]: Contractor };
    } = {
      ...contractorQuery,
      contractors: [],
      contractorsMap: {},
    };
    if (contractorEntitiesMap) {
      const contractors: Contractor[] = [];
      const contractorsMap: { [id: number]: Contractor } = {};

      for (const key in contractorEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(contractorEntitiesMap, key)) {
          const c = contractorEntitiesMap[key];
          const contractor = new Contractor(c);
          contractors.push(contractor);
          contractorsMap[contractor.id] = contractor;
        }
      }
      contractors.sort((a, b) => a.name.localeCompare(b.name));
      ret.contractors = contractors;
      ret.contractorsMap = contractorsMap;
    }

    return ret;
  }, [contractorEntitiesMap]);
}
